<template>
  <div>
    <div class="parent" :style="style" :class="[!showDetails ? 'parent-2' : '']">
      <v-card @click="showCoursefun">
        <v-card-title class="info-title">
          <font-awesome-icon v-if="!showDetails" class="collapse" icon="angle-left" />
          <div class="text-center text-padding">
            دوره {{ cycle.ID }}: {{ cycle.Name }}
          </div>
        </v-card-title>
        <div>
          <app-row icon="hashtag" title="تعداد واحد:" :value="cycle.TotalVahed" />
          <app-row icon="calculator" title="معدل:" :value="cycle.Avrg" />
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import DetailRow from "@/components/DetailRow";
export default {
  props: ["cycle", "index", "selectedCourse", "selectedVahed", "showDetails"],
  components: {
    appRow: DetailRow,
  },
  computed: {
    style() {
      var res = "";
      if (this.showDetails) {
        if (this.$store.getters.isMobile) {
          res = "width: 100%";
        } else {
          res = "width: calc(100% - 300px)";
        }
      }
      return res;
    },
  },
  methods: {
    showCoursefun() {
      if (!this.showDetails) {
        this.$emit("clicked", this.index);
      }
    },
  },
};
</script>
